import React, { FC, useState } from "react";
import { CREATE_CLIENT } from "../graphql/mutation";
import { ClientTemplateTab } from "@design-system";
import { Template } from "@design-system";
import { createClient, createClientVariables } from "../graphql/types";
import { ClientFilterData, clientPresentInSearch, useFilteredClientsLazy } from "../hooks/clients";
import { FILTERED_CLIENTS_QUERY } from "../graphql/query";
import { LibraryMatterType, usePaginatedMatterQuery } from "../hooks/use-paginated-matter-query";
import { MatterModalTemplateSearch } from "../types";
import { useMutation } from "../hooks";

type Props = {
  onSelect: (template: Template) => void;
  libraryMatterType: LibraryMatterType;
};
export const ClientTemplateTabContainer: FC<Props> = ({ onSelect, libraryMatterType }) => {
  const [client, setClient] = useState<any | null>(null);
  const [templateTitle, setTemplateTitle] = useState<string>("");
  const templateSearch = {
    value: templateTitle,
    onChange: setTemplateTitle,
  };
  const clientFilterData = useFilteredClientsLazy(10);

  const [createClient] = useMutation<createClient, createClientVariables>(CREATE_CLIENT, {
    update: (cache, mutationResult) => {
      const newClient = mutationResult.data?.createClient;
      const data: any = cache.readQuery({
        query: FILTERED_CLIENTS_QUERY,
        variables: clientFilterData?.queryVars,
      });
      if (data) {
        const queryVars = clientFilterData?.queryVars!.filter!.search! || "";
        const clientInSearch = clientPresentInSearch(queryVars, newClient);
        if (clientInSearch) {
          cache.writeQuery({
            query: FILTERED_CLIENTS_QUERY,
            variables: clientFilterData?.queryVars,
            data: {
              filteredClients: {
                clients: [...data.filteredClients.clients, newClient],
                total: data.filteredClients.total + 1,
              },
            },
          });
        }
      }
    },
  });

  const onClientSave = ((values: any) => {
    createClient({ variables: { data: values as any } });
  }) as any;
  return (
    <TemplateTabData
      onClientSave={onClientSave}
      onSelect={onSelect}
      libraryMatterType={libraryMatterType}
      onChangeClient={(client) => setClient(client)}
      clientId={client?.id}
      defaultClientValue={client}
      clientFilterData={clientFilterData}
      templateSearch={templateSearch}
    />
  );
};

type ListProps = {
  onSelect: (template: Template) => void;
  onClientSave: (client: any) => void;
  onChangeClient: (client: any) => void;
  defaultClientValue: any;
};

const TemplateTabData: FC<
  ListProps & {
    clientId: number;
    libraryMatterType: LibraryMatterType;
    clientFilterData: ClientFilterData;
    templateSearch: MatterModalTemplateSearch;
  }
> = ({
  onSelect,
  onClientSave,
  onChangeClient,
  libraryMatterType,
  defaultClientValue,
  clientFilterData,
  templateSearch,
}) => {
  const {
    matters,
    count,
    page,
    pageSize,
    loading,
    onChangeTitleSearch,
    onChangePage,
    onChangeClient: onChangeQueryClient,
  } = usePaginatedMatterQuery(libraryMatterType, {
    ...(defaultClientValue && {
      clientFilter: defaultClientValue.id,
    }),
    ...(templateSearch?.value && {
      titleFilter: templateSearch?.value,
    }),
  });
  return (
    <ClientTemplateTab
      items={(matters as unknown as Template[]) || []}
      loading={loading}
      onSelect={onSelect}
      onClientSave={onClientSave}
      onChangeClient={(client) => {
        onChangeQueryClient(client);
        onChangeClient(client);
      }}
      defaultClientValue={defaultClientValue}
      clientFilterData={clientFilterData}
      templateSearch={{
        value: templateSearch?.value,
        onChange: (v) => {
          onChangeTitleSearch(v);
          templateSearch?.onChange(v);
        },
      }}
      pagination={{
        current: page,
        onChange: onChangePage,
        total: count || 0,
        defaultPageSize: pageSize,
      }}
    />
  );
};
